export default class MapConstants {
    public static readonly ATTR_STROKE_STYLE = 'varStrokeStyle';
    public static readonly ATTR_TYPE = 'varType';
    public static readonly ATTR_SUBJECT = 'varSubject';
    public static readonly ATTR_SELECTED = 'varSelected';
    public static readonly ATTR_FLIGHT_MODEL = 'varFlightModel';
    public static readonly ATTR_MAJOR_IDX = 'varMajorIdx';
    public static readonly ATTR_MINOR_IDX = 'varMinorIdx';
    public static readonly ATTR_LABEL = 'varLabel';
    public static readonly ATTR_DISPLAY_TEXT = 'varDisplayText';
    public static readonly ATTR_FILL_COLOUR = 'varFillColour';
    public static readonly ATTR_TV_NAME = 'varTvName';
    public static readonly ATTR_TIME_PERIOD = 'varTimePeriod';

    public static readonly FLIGHT_POINT_TYPE = 'FlightPoint';
    public static readonly FLIGHT_TRAJECTORY_TYPE = 'FlightTrajectory';
    public static readonly FLIGHT_AIRSPACE_TYPE = 'FlightAirspace';
    public static readonly FLIGHT_TRAJECTORY_IN_AUA_TYPE = 'FlightTrajInAua';
    public static readonly AIRBLOCK_TYPE = 'Airblock3d';
    public static readonly TV_TYPE = 'TrafficVolume';
    public static readonly REGULATION_TYPE = 'Regulation';
    public static readonly REGULATION_SECTOR_TYPE = 'RegulationSector';
    public static readonly CENTER_POINT = 'CENTER_POINT';
    public static readonly TV_CONVECTION_TYPE = 'TvConvection';
    public static readonly POLYGON_CONVECTION_TYPE = 'PolygonConvection';
    public static readonly REGULATION_TV_LOCATION_TYPE = 'RegulationTVLocation';

    public static readonly BOX_SIZE_OVER_POINT = 0.2;

    public static readonly MAX_RESOLUTION_SHOW_POINT = 0.03;

    //user layers
    public static readonly ATTR_MONIT_TV_ALERT = 'varMonitTvAlert';
    public static readonly ATTR_MONIT_TV_FUTURE_ALERT = 'varMonitTvFutureAlert';
    public static readonly ATTR_MONIT_TV_FAR_FUTURE_ALERT = 'varMonitTvFutureAlert';
    public static readonly ATTR_MONIT_TV_IS_MONIT = 'varMonitTvNotMonit';
    // public static readonly ATTR_USER_LAYER_KEY = "varUserLayerKey";
    public static readonly ATTR_MEASURE_SCALE = 'varMeasureScale';
    public static readonly ATTR_MEASURE_DELAY = 'varMeasureDelay';
    public static readonly ATTR_MEASURE_AIRSPACE = 'varMeasureAirspace';
    public static readonly ATTR_MEASURE_STATE = 'varMeasureState';
    public static readonly ATTR_ELEMENT_HIGHLIGHT_STYLE = 'varElementHighlightStyle';
    public static readonly ATTR_MAP_LAYER_ID = 'varMapLayerId';
    public static readonly MAP_LAYER_LABEL_TYPE = 'MapLayerLabelType';
    public static readonly ACC_TYPE = 'Acc';
    public static readonly MILITARY_ZONE_TYPE = 'MilitaryZone';
    public static readonly ATTR_LABEL_CLUSTER_TITLE = 'varLabelClusterTitle';
    public static readonly ATTR_MEASURE_LOCATION_AERODROME = 'varMeasureLocationAerodrome';
    public static readonly NAT_TRACK_TYPE = 'NatTrack';
    public static readonly TV_IMPACT_TYPE = 'TvImpactType';
    public static readonly TV_IMPACT_SOLUTION_NAME = 'TvImpactSolutionName';
    public static readonly MEASURE_IMPACT_SOLUTION_NAME = 'MeasureImpactSolutionName';
    public static readonly MEASURE_IMPACT_TYPE = 'MeasureImpactType';
    public static readonly HOTSPOT_TYPE = 'HotspotType';
}
